export default (state, action) => {
  const { itemId, result } = action.payload;
  return {
    ...state,
    validationResults: {
      ...state.validationResults,
      [itemId]: result,
    },
  };
};
